<template>
  <div class="reum-textbox">
        <div class="reum-label">{{label}}</div>
        <input v-if="(type=='text' || type=='number' || type=='password') && !readonly" autocomplete="fake-name-disable-autofill" class="reum-text" :type="props.type" @focus="comp.showSelect" @keyup="comp.textChange" @change="comp.textChange" v-model="comp.val" @keypress.enter="comp.onKeyEnter" :placeholder="comp.placeholder">
        <input v-if="type=='select' && !readonly" autocomplete="fake-name-disable-autofill" readonly class="reum-text reum-select-cursor" type="text" @click="comp.showSelect" @keyup="comp.textChange" @change="comp.textChange" v-model="comp.select_text" :style="{color:comp.select_color}">
        <div class="reum-select-list" v-if="comp.flagSelect" @mouseleave="comp.hideSelect">
            <ul class="reum-select-item">
                <li v-for="(itm, idx) in comp.select_option" :key="idx" @click="comp.setSelectValue(itm)">{{itm.label}}</li>
            </ul>
        </div>
        <textarea v-if="type=='textarea' && !readonly" :style="{'height':height + 'px'}" @keyup="comp.textChange" @change="comp.textChange" v-model="comp.val" :placeholder="comp.placeholder"></textarea>
        <div v-if="readonly && (type=='text' || type=='number' || type=='password')" class="reum-readonly">{{comp.val}}</div>
        <div v-if="readonly && type=='select'" class="reum-readonly" :style="{color:comp.select_color}">{{comp.select_text}}</div>

  </div>
</template>

<script>
import { reactive, onMounted, watch } from "vue";


export default {
    name: "ReumTextBox",
    props: {
        modelValue: [String, Number],
        text : [String, Number],
        label: String,
        options: [Object, Array],
        readonly: {type: Boolean, default: false},
        type: {type: String, default: "text"},
        height: { type: Number, default: 150 },
        placeholder:{ type:String, default:"" }
    },
    setup(props, { emit }) {
        const comp = reactive({
            select_text: "",
            select_option: [{value:'1', label:"test1"}, {value:'2', label:"test2"}],
            select_color: "#3a3a3a",
            select_color_default: "#3a3a3a",

            placeholder:"",
            val : "",
            flagSelect: false,
            setSelectValue: (val) => {
                comp.val = val.value;
                comp.select_text = val.label;
                comp.flagSelect = false;
                emit("update:modelValue", comp.val);
                emit("change");
            },
            showSelect: () => {
                if(props.type=='select') {
                    comp.flagSelect = true;
                }
            },
            hideSelect: () => {
                comp.flagSelect = false;
            },
            textChange: () => {
                emit("update:modelValue", comp.val);
            },
            onKeyEnter: (e) => {
                emit("keypress.enter");
                e.target.blur();
            }
        });
        watch(() => props.options, (nVal, oVal) => {
            if(nVal != oVal) {
                comp.select_option = props.options;
            }
        });
        watch(() => props.modelValue, (nVal, oVal) => {
            if(nVal != oVal) {
                comp.val = props.modelValue;
            }
            if(props.type=='select') {
                if(typeof props.options == "object") {
                    comp.select_option = props.options;
                    for(let i=0;i<comp.select_option.length;i++) {
                        if(comp.select_option[i].value==comp.val) {
                            comp.select_text = comp.select_option[i].label;
                            
                            if(Object.prototype.hasOwnProperty.call(comp.select_option[i], 'color')) {
                                comp.select_color = comp.select_option[i].color;
                            } else {
                                comp.select_color = comp.select_option[i].select_color_default;
                            }
                        }
                    }
                }
            }
        });
        onMounted(() => {
            comp.val = props.modelValue;
            comp.placeholder = props.placeholder;
            if(props.type=='select') {
                if(typeof props.options == "object") {
                    comp.select_option = props.options;
                    for(let i=0;i<comp.select_option.length;i++) {
                        if(comp.select_option[i].value==comp.val) {
                            comp.select_text = comp.select_option[i].label;
                            if(Object.prototype.hasOwnProperty.call(comp.select_option[i], 'color')) {
                                comp.select_color = comp.select_option[i].color;
                            }
                        }
                    }
                }
            }
        });
        return { comp, props };
    }
}
</script>

<style lang="scss">
    @import "@/scss/_variables.scss";
    .reum-select-list {
        position: absolute;
        width: 100%;
        background-color: $backgroundColor;
        border: 1px solid #ddd;
        border-radius: 3px;
        z-index: 1000;
        .reum-select-item {
            li {
                padding: 8px 10px;
                cursor: pointer;
                &:hover {
                    background-color: rgba($primaryColor, .1);
                }
            }
        }
    }
    .reum-textbox {
        position: relative;
        padding-top: 10px;
        line-height: 100%;
        .reum-label {
            position: absolute;
            padding: 0 5px;
            top:2px;
            left: 17px;
            font-weight: bold;
            font-size: 13px;
            background-color: $backgroundColor;
            color: #101010;
        }
        .reum-text {
            padding: 10px 20px;
            border: 1px solid #C0C0C0;
            background-color: $backgroundColor;
            color: #3a3a3a;
            border-radius: 20px;
        }
        textarea {
            padding: 10px 20px;
            border: 1px solid #C0C0C0;
            background-color: $backgroundColor;
            color: #3a3a3a;
            // font-family: 'Roboto', sans-serif;

            font-family: Arial;
        }
    }
    .reum-select-cursor {
        cursor: pointer;
    }
    .reum-readonly {
        width : 100%;
        box-sizing: border-box;
        font-weight: normal;
        min-height: 39px;
        line-height: 27px;
        padding: 5px 10px;
        color: #3a3a3a;
        outline: none;
        border: 1px solid #ddd;
        font-size: 15px;
        &:focus {
            border: 1px solid $primaryColor;
        }
    }
    textarea {
        width : 100%;
        padding: 5px 10px;
        outline: none;
        border: 1px solid #ddd;
        font-size: 15px;
        box-sizing: border-box;
        &:focus {
            border: 1px solid $primaryColor;
        }
    }

    input[type="text"], input[type="password"], input[type="number"] {
        width : 100%;
        padding: 5px 10px;
        outline: none;
        border: 1px solid #ddd;
        font-size: 15px;
        box-sizing: border-box;
        &:focus {
            border: 1px solid $primaryColor;
        }
    }

    input:-webkit-autofill,
    input:-webkit-autofill:hover, 
    input:-webkit-autofill:focus, 
    input:-webkit-autofill:active{
        -webkit-box-shadow: 0 0 0 30px $backgroundColor inset !important;
    }

</style>